<template>
  <ClientOnly>
    <div class="p-6 bg-white rounded-lg">
      <div class="font-bold text-xl mb-4">My Transaction</div>
      <MazTabs @update:model-value="onTabChange" class="mb-4">
        <MazTabsBar :items="tabs" />
      </MazTabs>

      <MazTable
        size="sm"
        v-model:search-query="query.search"
        v-model:page="query.page"
        v-model:page-size="query.pageSize"
        pagination
        color="secondary"
        hoverable
        background-even
        :headers="[
          { label: 'ID Transaction', key: 'transaction_id' },
          { label: 'Transaction Type', key: 'type' },
          { label: 'Date', key: 'date' },
        ]"
        :rows="filteredTransactions"
      >
        <template #cell-type="{ value }">
          <MazBadge
            :color="value === 'SUBSCRIPTION' ? 'primary' : 'secondary'"
            >{{ value }}</MazBadge
          >
        </template>

        <template #actions="{ row }">
          <div class="flex gap-2 p-4">
            <MazBtn size="xs" color="secondary" @click="showDetailHandler(row)">
              <Icon name="mdi-eye" />
            </MazBtn>
          </div>
        </template>
      </MazTable>
    </div>

    <MazDialog v-model="showDetail" title="Detail Transaction">
      Detail Transaction
    </MazDialog>
  </ClientOnly>
</template>

<script lang="ts" setup>
const showDetail = ref(false);
const selectedDetail = ref({});

const tabs = [
  { label: "On Going", disabled: false },
  { label: "History", disabled: false },
];

const query = reactive({
  page: 1,
  pageSize: 5,
  search: "",
});

const transactions = ref([
  {
    id: "0262672d-7c7a-4d30-866e-edb88b5a5336",
    transaction_id: "TR-11-1239",
    type: "BOOKING",
    date: "11 Oct 2024",
  },
  {
    id: "b8b6727e-5c4f-4d85-b8f6-fc605d3b660b",
    transaction_id: "TR-11-1240",
    type: "SUBSCRIPTION",
    date: "12 Oct 2024",
  },
  {
    id: "d9b1a48a-9301-4f4b-977c-d6231cb4e63b",
    transaction_id: "TR-11-1241",
    type: "BOOKING",
    date: "13 Oct 2024",
  },
  {
    id: "e29a29b1-39de-4ae4-b16e-b71a61c2c872",
    transaction_id: "TR-11-1242",
    type: "SUBSCRIPTION",
    date: "14 Oct 2024",
  },
  {
    id: "fdbe93c5-6c57-4a6e-9b2f-0c92951c82e5",
    transaction_id: "TR-11-1243",
    type: "BOOKING",
    date: "15 Oct 2024",
  },
  {
    id: "a8c0d067-8b69-4e9c-a47a-c6b5375b4c1b",
    transaction_id: "TR-11-1244",
    type: "SUBSCRIPTION",
    date: "16 Oct 2024",
  },
  {
    id: "3f1c3c92-12b4-4038-a5d2-3f91880c4c7c",
    transaction_id: "TR-11-1245",
    type: "BOOKING",
    date: "17 Oct 2024",
  },
]);

// ---- Get Data
const filteredTransactions = ref(transactions.value);

const shuffleArray = (array: any) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const onTabChange = () => {
  // Shuffle transactions when the tab changes
  filteredTransactions.value = shuffleArray([...transactions.value]);
};

// Initialize with random transactions
filteredTransactions.value = shuffleArray([...transactions.value]);

// ----- Actions
const showDetailHandler = (row: any) => {
  Object.assign(selectedDetail, row);
  showDetail.value = true;
};
</script>
